function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 80;\n  background-color: secondary-bg;\n  border-top: 1;\n  border-bottom: 1;\n  border-color: border;\n  padding-top: 50;\n  padding-bottom: 50;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  h2 {\n    padding: 0;\n    font-weight: 500;\n    margin-bottom: 10;\n    font-size: 34;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import styled from '@xstyled/styled-components';
export var ShowCase = styled.div(_templateObject());